/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../../api/index';
import * as core from '../../../../../core';
import * as serializers from '../../../../index';

export const FileUpdateAnnotationsRequest: core.serialization.Schema<
    serializers.FileUpdateAnnotationsRequest.Raw,
    Omit<Truvity.FileUpdateAnnotationsRequest, 'idempotencyKey' | 'ifMatch'>
> = core.serialization.object({
    annotations: core.serialization.record(core.serialization.string(), core.serialization.string()),
});

export declare namespace FileUpdateAnnotationsRequest {
    export interface Raw {
        annotations: Record<string, string>;
    }
}
